// -------Accordion-sec----------



var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}


// home page collection grid

const cl1 = document.querySelectorAll("#shopify-section-161504259597933aee .skrim__link")[0];
cl1.setAttribute("href", "https://byob-custom-wig-bar.myshopify.com/pages/wig-customization-bar");

const cl2 = document.querySelectorAll("#shopify-section-161504259597933aee .skrim__link")[1];
cl2.setAttribute("href", "https://www.byobwigbar.com/collections/category-2");

const cl3 = document.querySelectorAll("#shopify-section-161504259597933aee .skrim__link")[2];
cl3.setAttribute("href", "https://byob-custom-wig-bar.myshopify.com/collections/category-1");